<template>
  <div
    class="end-root flex-col w-full h-full flex justify-start items-center px-6 md:px-20"
    @click="goBack"
  >
    <div class="end-titles flex flex-col w-full text-center mt-16 md:mt-32">
      <h1 class="screen-info text-2xl md:text-4xl">{{ title }}</h1>
      <h2 class="screen-name mt-8" v-html="text"></h2>
    </div>
    <div class="end-art flex flex-1 justify-center w-3/4">
      <img :src="brandAsset(endImg, endImgSanne)" />
    </div>
    <leave-button @click="goBack" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import i18n from '@/i18n';
import page from '@/mixins/page';
import audioPlayer from '@/mixins/audio-player';
import LeaveButton from '@/components/common/LeaveButton.vue';
import brandMode from '@/mixins/brand-mode';
import endImg from '@/assets/Ending/end.svg';
import endImgSanne from '@/assets/sanne/ending.svg';

export default {
  name: 'End',
  components: { LeaveButton },
  mixins: [page, audioPlayer, brandMode],
  data: () => ({ endImg, endImgSanne }),
  mounted() {
    this.playAudio('19-Thank_you');
    this.timer = setTimeout(
      () => {
        this.goBack();
      },
      this.isHM ? 8000 : 15000
    );
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    goBack() {
      if (this.exitOnScanComplete) {
        this.$events.goto('Close');
      } else {
        this.$events.goto(this.isContactless ? 'Welcome' : 'HomePage');
      }
    },
  },
  computed: {
    ...mapState('app', ['exitOnScanComplete']),
    title() {
      if (this.isHM) return i18n.t('hm.end_title');
      if (this.isSanne) return i18n.t('sanne.end_title');
      return i18n.t('end.thank');
    },
    text() {
      if (this.isHM) return i18n.t('hm.end_text');
      if (this.isSanne) return i18n.t('sanne.end_hint');
      return i18n.t('end.belonging');
    },
  },
};
</script>

<style lang="scss" scoped>
.screen-name {
  @apply text-base w-4/5 mx-auto;
  @screen md {
    @apply text-2xl;
    line-height: 1.67;
  }
  line-height: 1.25;
  color: #262626;
}
.screen-info {
  font-weight: bold;
  line-height: 1.39;
  color: #2c2c2c;
}
</style>
